



































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Period from "@/models/annoucement/period.Model";
@Component
export default class InitperiodEdit extends GenericEdit<Period> {
  constructor() {
    super();
    this.controller = 'Periods';
    this.model = new Period();
  }
}
